import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IPositionProps {
    columnPosition: number;
}
  
export const FontReplaceContainer = styled.div`
  padding: 37px 0px 0px 0px;
  width: 50%;
  display: flex;
  justify-content: ${(props: IPositionProps) => props.columnPosition===0 ? `flex-start` : 'flex-end'};
`

export const FontReplaceItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

export const FontTitle = styled.span`
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
`

export const ReplaceMessage = styled.span`
  padding: 12px 0px 0px 0px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #204078;
`
